export const gameDetailsController = {
  initial: 'off',
  states: {
    off: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'isControllerEnabled_gameDetails',
        },
      },
    },
    on: {
      entry: [
        'updateSiteTrackingStorageInfo',
        'updateRegistrationComponentMode',
        {
          type: 'batchLayoutOperations',
          data: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.Modal.properties.titleKey',
                value: 'gameInfoTitle',
              },
            },
          ],
        },
        'scrollTop',
      ],
      on: {
        LAYOUT_CHANGE_END: [
          {
            target: 'off',
            cond: 'isControllerDisabled_gameDetails',
          },
          {
            target: 'refreshing',
          },
        ],
        VIEW_MODAL_BACK_BUTTON_CLICK: {
          actions: ['goBack'],
          target: 'off',
        },
      },
    },
    refreshing: {
      always: 'on',
    },
  },
};
